var _excluded = ["name"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { defineComponent } from '../utils/create';
import { props } from './props';
export default defineComponent({
  _scopeId: 'data-v-abded948',
  name: 'CbTabs',
  props,
  data() {
    return {
      tabs: []
    };
  },
  inheritAttrs: false,
  computed: {
    activeTab() {
      return this.value;
    },
    tabHeaderStyles() {
      var tab = this.tabs.find(x => x.name === this.value);
      if (!tab) {
        return _extends({}, this.tabsHeaderStyle);
      }
      return _extends({}, this.tabsHeaderStyle, {
        'background-image': "url(\"" + (tab.activeBackground || '') + "\")"
      });
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        var newTab = this.tabs.find(t => t.name === newVal);
        newTab && this.handleTabChange(newTab);
      }
    }
  },
  methods: {
    handleTabChange(tab) {
      if (tab.disabled) {
        typeof this.onDisabledTabClick === 'function' && this.onDisabledTabClick();
        return;
      }
      if (tab.name === this.value) {
        return;
      }
      this.$emit('input', tab.name);
      this.$emit('change', tab.name);
    },
    getTabHeaderClassName(tab) {
      return {
        'tabs-header-item': true,
        active: this.activeTab === tab.name
      };
    },
    registerTab(tab) {
      if (this.tabs.find(x => x.name === tab.name)) {
        console.log('the tab has registry');
        return;
      }
      this.tabs.push(tab);
    },
    updateTab(newTab) {
      var {
          name
        } = newTab,
        rest = _objectWithoutPropertiesLoose(newTab, _excluded);
      var oldTab = this.tabs.find(x => x.name === name);
      if (!oldTab) {
        return;
      }
      Object.assign(oldTab, rest);
    },
    unregisterTab(tab) {
      if (!this.tabs.find(x => x.name === tab.name)) {
        console.log('the tab not exist');
        return;
      }
      var idx = this.tabs.findIndex(x => x.name === tab.name);
      this.tabs.splice(idx, 1);
    }
  },
  render() {
    var h = arguments[0];
    return h("div", {
      "class": "tabs",
      "attrs": {
        "data-key": this.id
      }
    }, [h("div", {
      "class": "tabs-header",
      "style": this.tabHeaderStyles,
      "attrs": {
        "data-key": this.id
      }
    }, [this.tabs.map(tab => {
      return h("div", {
        "class": this.getTabHeaderClassName(tab),
        "key": tab.name,
        "style": _extends({}, tab.tabHeaderStyle || {}, {
          flex: tab.weight || 1
        }),
        "on": _extends({}, {
          click: () => {
            this.handleTabChange(tab);
          }
        })
      });
    })]), h("div", {
      "class": "tabs-body",
      "style": this.tabsBodyStyle,
      "attrs": {
        "data-key": this.id
      }
    }, [this.$slots.default])]);
  }
});